import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["nav"]

  connect() {
    this.tabs = Array.from(
      this.navTarget.querySelectorAll(".nav-link")
    )
  }

  previous() {
    this.changeTab(-1)
  }

  next() {
    this.changeTab(1)
  }

  changeTab(direction) {
    const activeIndex = this.tabs.findIndex(tab =>
      tab.classList.contains("active")
    )

    if (activeIndex === -1) return

    const newIndex =
      (activeIndex + direction + this.tabs.length) % this.tabs.length

    bootstrap.Tab.getOrCreateInstance(this.tabs[newIndex]).show()

    this.navTarget.scrollBy({
      left: direction * 220,
      behavior: "smooth"
    })
  }
}